var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},_vm.$listeners),[_c('path',{attrs:{"d":"M448.1 32h-384C28.75 32 .1 60.65.1 96v320c0 35.35 28.65 64 64 64h384c35.35 0 64-28.65 64-64V96c0-35.35-28.7-64-64-64zM232.2 432h-168c-8.837 0-16-7.163-16-16V144h184v288zm232-16c0 8.837-7.163 16-16 16h-168V144h184v272z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }